import {z} from 'zod';
import {ObjectId} from 'bson';

export const WithIdSchema = {
  _id: z.instanceof(ObjectId),
};

export type ApiOptions = {
  access: 'admin' | 'paid' | 'all';
};

// The ApiDefinition is the contract between the client the server for a given route.
export interface ApiDefinition<RequestData = unknown, ResponseData = unknown> {
  path: string;
  method: 'get' | 'post';
  options: ApiOptions;
  requestDataSchema: z.ZodType<RequestData>;
  responseDataSchema: z.ZodType<ResponseData>;
}

export interface BatchedApiDefinition<
  BatchedRequestData,
  BatchedResponseData,
  Item,
  ItemResponseData,
> extends ApiDefinition<BatchedRequestData, BatchedResponseData> {
  maxBatchSize?: number;
  itemSchema: z.ZodType<Item>;
  itemResponseDataSchema: z.ZodType<ItemResponseData>;

  createParams: (items: Item[]) => BatchedRequestData;
  resolveItem: (
    items: BatchedResponseData,
    item: Item
  ) => ItemResponseData | null;
}
